import { Inject, Injectable } from '@angular/core';
import { Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt';
import { DocumentoRichiestaMutuo, Profilo, RichiestaMutuo, RichiestaMutuoCambioStato, RichiestaMutuoSearch, StaticUrls } from 'app/models';
import { Mediatore } from 'app/models/mediatore';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { MyCookieService } from './my-cookie.service';

@Injectable()
export class RichiestaMutuoService {

  private richiestaMutuo: RichiestaMutuo;
  private richiesteMutuo: Array<RichiestaMutuo>;
  private documenti: Array<DocumentoRichiestaMutuo>;
  private mediatore: Mediatore;
  
  private headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: AuthHttp, private router: Router,
    @Inject(MyCookieService) private myCookieService: MyCookieService) { }

  search(richiestaMutuoSearch: RichiestaMutuoSearch): Observable<Array<RichiestaMutuo>> {
    return this.http.post(StaticUrls.richiesta_mutuo_search, richiestaMutuoSearch)
      .map(this.extractData)
      .catch(this.handleError);
  }

  searchMy(richiestaMutuoSearch: RichiestaMutuoSearch): Observable<Array<RichiestaMutuo>> {
    return this.http.post(StaticUrls.richiesta_mutuo_search_my, richiestaMutuoSearch)
      .map(this.extractData)
      .catch(this.handleError);
  }

  countSearch(richiestaMutuoSearch: RichiestaMutuoSearch): Observable<number>  {
    return this.http.post(StaticUrls.richiesta_mutuo_search_count, richiestaMutuoSearch)
      .map(counter => { return counter.json(); });
  }

  countSearchMy(richiestaMutuoSearch: RichiestaMutuoSearch): Observable<number>  {
    return this.http.post(StaticUrls.richiesta_mutuo_search_count_my, richiestaMutuoSearch)
      .map(counter => { return counter.json(); });
  }

  get(id: number): Observable<RichiestaMutuo> {
    return this.http.get(StaticUrls.richiesta_mutuo_by_id(id))
      .map(this.extractDataObj)
      .catch(this.handleError);
  }

  getDocumentiRichiesta(idRichiesta: number, idTipologia: number): Observable<Array<DocumentoRichiestaMutuo>> {
    return this.http.get(StaticUrls.richiesta_mutuo_get_doc_richiesta(idRichiesta, idTipologia))
      .map(this.extractDataDocObj)
      .catch(this.handleError);
  }

  getDocumentiRichiedente(idRichiesta: number, idRichiedenti: number, idTipologia: number): Observable<Array<DocumentoRichiestaMutuo>> {
    return this.http.get(StaticUrls.richiesta_mutuo_get_doc_richiedente(idRichiesta, idRichiedenti, idTipologia))
      .map(this.extractDataDocObj)
      .catch(this.handleError);
  }

  insert(richiestaMutuo: RichiestaMutuo): Observable<RichiestaMutuo> {
    return this.http.post(StaticUrls.richiesta_mutuo, richiestaMutuo)
      .map(this.extractDataObj);
  }

  update(richiestaMutuo: RichiestaMutuo): Observable<RichiestaMutuo> {
    return this.http.put(StaticUrls.richiesta_mutuo, richiestaMutuo)
      .map(this.extractDataObj);
  }

  updateStato(richiesta: RichiestaMutuoCambioStato): Observable<Response> {
    return this.http.put(StaticUrls.richiesta_mutuo_update_stato, richiesta);
  }

  inoltra(richiestaMutuo: RichiestaMutuo): Observable<RichiestaMutuo> {
    return this.http.post(StaticUrls.richiesta_mutuo_inoltra, richiestaMutuo)
      .map(this.extractDataObj)
  }

  insertNa(richiestaMutuo: RichiestaMutuo): Observable<RichiestaMutuo> {
    return this.http.post(StaticUrls.richiesta_mutuo_insert_na, richiestaMutuo)
      .map(this.extractDataObj);
  }

  inoltraNa(richiestaMutuo: RichiestaMutuo): Observable<RichiestaMutuo> {
    return this.http.post(StaticUrls.richiesta_mutuo_inoltra_na, richiestaMutuo)
      .map(this.extractDataObj);
  }

  deleteIntestatarioGarante (id: number): Observable<Response> {
    return this.http.delete(StaticUrls.richiesta_mutuo_delete_intestatario(id));
  }

  deleteImpegno(id: number): Observable<Response> {
    return this.http.delete(StaticUrls.richiesta_mutuo_delete_impegno(id));
  }

  getJsonFile(richiestaMutuoSearch: RichiestaMutuoSearch) {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				const optionsHeaderBlob = new RequestOptions({ responseType: ResponseContentType.Blob, headers: this.headers } );
				return this.http.post(StaticUrls.richiesta_mutuo_json_file, richiestaMutuoSearch, optionsHeaderBlob)
					.map(res => {
						if(res.status === 204){
							return res;
						} else {
							return { filename: 'elenco-richieste.json', data: res.blob() };
						}
					}).catch(this.handleError);
			}
		}
  }

  getCsvFile(richiestaMutuoSearch: RichiestaMutuoSearch) {
		if (this.myCookieService.token) {
			if (this.ifTokenNotExpired()) {
				const optionsHeaderBlob = new RequestOptions({ responseType: ResponseContentType.Blob, headers: this.headers } );
				return this.http.post(StaticUrls.richiesta_mutuo_csv_file, richiestaMutuoSearch, optionsHeaderBlob)
					.map(res => {
						if(res.status === 204){
							return res;
						} else {
							return { filename: 'elenco-richieste.csv', data: res.blob() };
						}
					}).catch(this.handleError);
			}
		}
  }
  
  countRichieste(statoRichiesta: string): Observable<number> {
    return this.http.get(StaticUrls.richiesta_mutuo_count(statoRichiesta))
      .map(this.extractDataObj)
      .catch(this.handleError);
  }

  getMediatore(): Observable<Mediatore> {
    return this.http.get(StaticUrls.richiesta_mutuo_mediatore)
    .map(this.extractDataMediatore)
  }

  sendEmail(profilo: Profilo):Observable<Response> {
    return this.http.post(StaticUrls.richiesta_mutuo_email, profilo)
    .map((response: Response) => {
      return response;
  });
  }

  private ifTokenNotExpired() {
		if (this.myCookieService.token) {
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

  private extractData(res: Response) {
		this.richiesteMutuo = res.json();
		return this.richiesteMutuo;
	}

	private extractDataObj(res: Response) {
		this.richiestaMutuo = res.json();
		return this.richiestaMutuo;
  }

  private extractDataDocObj(res: Response) {
    this.documenti = res.json();
		return this.documenti;
  }
  
  private extractDataMediatore(res: Response) {
    this.mediatore = res.json();
    return this.mediatore;
  }

  private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/richiesta-mutuo.service.ts